"use strict";

exports.__esModule = true;
exports.publicContext = exports.PublicConsumer = exports.PublicProvider = exports.Context = exports.Consumer = exports.Provider = void 0;

var _react = require("react");

var Context = /*#__PURE__*/(0, _react.createContext)();
exports.Context = Context;
var Provider = Context.Provider,
    Consumer = Context.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;
var publicContext = /*#__PURE__*/(0, _react.createContext)();
exports.publicContext = publicContext;
var PublicProvider = publicContext.Provider,
    PublicConsumer = publicContext.Consumer;
exports.PublicConsumer = PublicConsumer;
exports.PublicProvider = PublicProvider;